// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: HUdJ1-BuRo

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicDragHandle.module.css"; // plasmic-import: HUdJ1-BuRo/css

import UpButtonIcon from "./icons/PlasmicIcon__UpButton"; // plasmic-import: TOOAu8jOY/icon
import DownButtonIcon from "./icons/PlasmicIcon__DownButton"; // plasmic-import: dz0dmgcz2r/icon

createPlasmicElementProxy;

export type PlasmicDragHandle__VariantMembers = {
  showUpDown: "showUpDown";
};
export type PlasmicDragHandle__VariantsArgs = {
  showUpDown?: SingleBooleanChoiceArg<"showUpDown">;
};
type VariantPropType = keyof PlasmicDragHandle__VariantsArgs;
export const PlasmicDragHandle__VariantProps = new Array<VariantPropType>(
  "showUpDown"
);

export type PlasmicDragHandle__ArgsType = {};
type ArgPropType = keyof PlasmicDragHandle__ArgsType;
export const PlasmicDragHandle__ArgProps = new Array<ArgPropType>();

export type PlasmicDragHandle__OverridesType = {
  root?: p.Flex<"div">;
  dragHandle?: p.Flex<"div">;
  upButton?: p.Flex<"button">;
  up?: p.Flex<"svg">;
  handle?: p.Flex<"button">;
  img?: p.Flex<typeof p.PlasmicImg>;
  downButton?: p.Flex<"button">;
  down?: p.Flex<"svg">;
};

export interface DefaultDragHandleProps {
  showUpDown?: SingleBooleanChoiceArg<"showUpDown">;
  className?: string;
}

const $$ = {};

function PlasmicDragHandle__RenderFunc(props: {
  variants: PlasmicDragHandle__VariantsArgs;
  args: PlasmicDragHandle__ArgsType;
  overrides: PlasmicDragHandle__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "showUpDown",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.showUpDown
      },
      {
        path: "variable",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover
  };

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"dragHandle"}
        data-plasmic-override={overrides.dragHandle}
        hasGap={true}
        className={classNames(projectcss.all, sty.dragHandle, {
          [sty.dragHandleshowUpDown]: hasVariant(
            $state,
            "showUpDown",
            "showUpDown"
          )
        })}
      >
        {(
          triggers.hover_root
            ? true
            : hasVariant($state, "showUpDown", "showUpDown")
            ? true
            : false
        ) ? (
          <button
            data-plasmic-name={"upButton"}
            data-plasmic-override={overrides.upButton}
            className={classNames(
              projectcss.all,
              projectcss.button,
              sty.upButton,
              {
                [sty.upButtonshowUpDown]: hasVariant(
                  $state,
                  "showUpDown",
                  "showUpDown"
                )
              }
            )}
            ref={ref => {
              $refs["upButton"] = ref;
            }}
          >
            <UpButtonIcon
              data-plasmic-name={"up"}
              data-plasmic-override={overrides.up}
              className={classNames(projectcss.all, sty.up)}
              role={"img"}
            />
          </button>
        ) : null}
        <button
          data-plasmic-name={"handle"}
          data-plasmic-override={overrides.handle}
          className={classNames(projectcss.all, projectcss.button, sty.handle)}
          disabled={false}
          ref={ref => {
            $refs["handle"] = ref;
          }}
        >
          <p.PlasmicImg
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"1em"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"1.25em"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/6e906c84ad74fc27d54f0b4f037d625e.svg",
              fullWidth: 20,
              fullHeight: 17,
              aspectRatio: 1.5
            }}
          />
        </button>
        {(
          triggers.hover_root
            ? true
            : hasVariant($state, "showUpDown", "showUpDown")
            ? true
            : false
        ) ? (
          <button
            data-plasmic-name={"downButton"}
            data-plasmic-override={overrides.downButton}
            className={classNames(
              projectcss.all,
              projectcss.button,
              sty.downButton,
              {
                [sty.downButtonshowUpDown]: hasVariant(
                  $state,
                  "showUpDown",
                  "showUpDown"
                )
              }
            )}
            ref={ref => {
              $refs["downButton"] = ref;
            }}
          >
            <DownButtonIcon
              data-plasmic-name={"down"}
              data-plasmic-override={overrides.down}
              className={classNames(projectcss.all, sty.down)}
              role={"img"}
            />
          </button>
        ) : null}
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "dragHandle",
    "upButton",
    "up",
    "handle",
    "img",
    "downButton",
    "down"
  ],
  dragHandle: [
    "dragHandle",
    "upButton",
    "up",
    "handle",
    "img",
    "downButton",
    "down"
  ],
  upButton: ["upButton", "up"],
  up: ["up"],
  handle: ["handle", "img"],
  img: ["img"],
  downButton: ["downButton", "down"],
  down: ["down"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  dragHandle: "div";
  upButton: "button";
  up: "svg";
  handle: "button";
  img: typeof p.PlasmicImg;
  downButton: "button";
  down: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDragHandle__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDragHandle__VariantsArgs;
    args?: PlasmicDragHandle__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicDragHandle__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicDragHandle__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDragHandle__ArgProps,
          internalVariantPropNames: PlasmicDragHandle__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDragHandle__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDragHandle";
  } else {
    func.displayName = `PlasmicDragHandle.${nodeName}`;
  }
  return func;
}

export const PlasmicDragHandle = Object.assign(
  // Top-level PlasmicDragHandle renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dragHandle: makeNodeComponent("dragHandle"),
    upButton: makeNodeComponent("upButton"),
    up: makeNodeComponent("up"),
    handle: makeNodeComponent("handle"),
    img: makeNodeComponent("img"),
    downButton: makeNodeComponent("downButton"),
    down: makeNodeComponent("down"),

    // Metadata about props expected for PlasmicDragHandle
    internalVariantProps: PlasmicDragHandle__VariantProps,
    internalArgProps: PlasmicDragHandle__ArgProps
  }
);

export default PlasmicDragHandle;
/* prettier-ignore-end */
